
export const VERSION_WEB = "1.0.0";

export const optionMonedas = [
  { label: 'Guaranies', value: "Guaranies", id: 1 },
  { label: 'Dolares', value: "Dolares", id: 2 }
];

export const optionMotivosRechazos = [
  { label: 'La factura no corresponde al usuario', value: "La factura no corresponde al usuario", id: 1 },
  { label: 'La factura no es del paso', value: "La factura no es del paso", id: 2 },
  { label: 'La foto no se puede procesar', value: "La foto no se puede procesar", id: 3 },
  { label: 'Factura repetida', value: "Factura repetida", id: 4 },
  { label: 'La factura no alcanza el ratio mínimo de la promoción', value: "La factura no alcanza el ratio mínimo de la promoción", id: 5 },
  { label: 'Otros', value: "Otros", id: 6 },
];

export const optionsGenero = [
  { label: 'Masculino', value: "masculino", id: 1 },
  { label: 'Femenino', value: "femenino", id: 2 }
];

export const VigenciaPublicaciones = [
  { label: 'Vigente', value: "vigente", id: 1 },
  { label: 'Inactivo', value: "inactivo", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

export const VigenciaPromociones = [
  { label: 'Vigente', value: "vigente", id: 1 },
  { label: 'Inactivo', value: "inactivo", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

export const optionsEstadoUsuarios = [
  { label: 'Activo', value: "activo", id: 1 },
  { label: 'Inactivo', value: "inactivo", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];


export const optionsEventosPromociones = [
  { label: 'Vigentes', value: "vigentes", id: 1 },
  { label: 'Inactivos', value: "inactivos", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

export const optionsEstado = [
  { label: 'Activo', value: "activo", id: 1 },
  { label: 'Eliminados', value: "eliminados", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

export const optionsSorteos = [
  { label: 'Sorteo de Prueba', id: 1 },
  { label: 'Viaja con mamá', id: 2 },
  { label: 'Prueba 10', id: 3 },
];

export const optionsProcesados = [
  { label: 'Todos', value: "todos", id: 1 },
  { label: 'Sistema', value: "sistema", id: 2 },
  { label: 'Usuarios del sistema', value: "usuarios_del_sistema", id: 3 },
  { label: 'Atención al cliente', value: "atencion_al_cliente", id: 4 }, ,
];

export const optionsCuponesAnulados = [
  { label: 'Si', value: "si", id: 1 },
  { label: 'No', value: "no", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

export const optionsEmailVerificado = [
  { label: 'Si', value: "si", id: 1 },
  { label: 'No', value: "no", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

export const optionsUsuarios = [
  { label: 'Luciano Armoa', id: 1 },
  { label: 'Emmanuel Jara', id: 2 },
  { label: 'Franco Jara', id: 3 },
];

export const optionsTipo = [
  { label: 'Todos', value: "todos", id: 1 },
  { label: 'Pertenece al complejo', value: "pertenece_al_complejo", id: 2 },
  { label: 'No pertenece al complejo', value: "no_pertenece_al_complejo", id: 3 },
];

export const optionsUserTester = [
  { label: 'Todos', value: "todos", id: 1 },
  { label: 'Si', value: "si", id: 2 },
  { label: 'No', value: "no", id: 3 },
];

export const dataDashboardActividad = [
  {
    label: 'Nuevos Usuarios',
    cantidad: 300,
    imagen: require('../assets/imagenes/usuarios.png'),
    id: 1
  },
  {
    label: 'Usuarios Activos',
    cantidad: 100,
    imagen: require('../assets/imagenes/grafico-de-barras.png'),
    id: 2
  },
  {
    label: 'Cuentas eliminadas',
    cantidad: 20,
    imagen: require('../assets/imagenes/borrar-archivo.png'),
    id: 3
  },
];

export const dataInformacionAdicional = {
  dataSesion: [
    {
      label: 'Google',
      cantidad: 300,
      imagen: require('../assets/imagenes/usuarios.png'),
      id: 1
    },
    {
      label: 'Facebook',
      cantidad: 100,
      imagen: require('../assets/imagenes/grafico-de-barras.png'),
      id: 2
    },
    {
      label: 'Apple',
      cantidad: 20,
      imagen: require('../assets/imagenes/borrar-archivo.png'),
      id: 3
    },
    {
      label: 'Correo Electrónico',
      cantidad: 20,
      imagen: require('../assets/imagenes/borrar-archivo.png'),
      id: 3
    },
  ],
  dataStatus: [
    {
      label: 'Promociones Activas',
      cantidad: 2,
      imagen: require('../assets/imagenes/vale.png'),
      id: 1
    },
    {
      label: 'Pendiente de verificación',
      cantidad: 40,
      imagen: require('../assets/imagenes/elementos-de-la-lista.png'),
      id: 2
    },
    {
      label: 'Total de usuarios',
      cantidad: 900,
      imagen: require('../assets/imagenes/usuarios.png'),
      id: 3
    },
  ]
};

export const optionsEstadoPromciones = [
  { label: 'Vigentes', id: 1 },
  { label: 'Inactivos', id: 2 },
  { label: 'Todos', id: 3 },
];